import { render, staticRenderFns } from "./ViewFormsProcesos.vue?vue&type=template&id=b66ed556"
import script from "./ViewFormsProcesos.vue?vue&type=script&lang=js"
export * from "./ViewFormsProcesos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports